import AuthSlider from "../components/AuthSlider";
  
const Login = () => {
  return (
    <div style={{ minHeight: "100vh", display: "grid", placeItems: "center", background: "#2166ab", margin: "0%" }}>
      <AuthSlider />
    </div>
  );
};

export default Login;